import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Transition, Segment, Grid } from "semantic-ui-react";
import SearchField from "../shared/SearchField";
import _ from "lodash";
import { busquedasOps } from "../../ducks/busquedas";

class Busquedas extends React.Component {
  state = {
    visible: false
  };

  componentDidMount() {
    this.setState({ visible: true });
    this.props.fetchSearchDataAlumnos();
    this.props.fetchSearchDataColegios();
    this.props.fetchSearchDataActividades();
  }

  componentWillUnmount() {
    this.props.resetSearchData();
    this.props.detachSearchData();
  }

  handleSearchFieldAction = (field, { busqueda }) => {
    const listado = _.isEmpty(busqueda);

    switch (field) {
      case "buscarAlumno":
        listado
          ? this.showListado("alumnos")
          : this.showDetalle("alumno", busqueda);
        break;
      case "buscarColegio":
        listado
          ? this.showListado("colegios")
          : this.showDetalle("colegio", busqueda);
        break;
      case "buscarActividad":
        listado
          ? this.showListado("actividades")
          : this.showDetalle("actividad", busqueda);
        break;

      default:
        break;
    }
  };

  showListado = tipo => {
    this.props.history.push(
      tipo === "alumnos"
        ? "/extraescolares/listado/alumnos"
        : tipo === "colegios"
          ? "/extraescolares/listado/colegios"
          : "/extraescolares/listado/actividades"
    );
  };

  showDetalle = (tipo, busqueda) => {
    this.props.history.push(
      tipo === "alumno"
        ? `/detalle/alumno/${busqueda}`
        : tipo === "colegio"
          ? `/detalle/colegio/${busqueda}`
          : `/detalle/actividad/${busqueda}`
    );
  };

  render() {
    return (
      <Transition.Group animation="scale" duration={150}>
        {this.state.visible && (
          <Segment textAlign="center">
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <SearchField
                    form="SearchAlumnoForm"
                    fieldID="buscarAlumno"
                    fieldName="busqueda"
                    labelText="Búsqueda de Alumnos"
                    placeholder="Nombre del alumno"
                    handleButtonClick={this.handleSearchFieldAction}
                    datosBusqueda={this.props.searchDataAlumnos}
                    showAddButton={true}
                    botonLink="/nuevo/alumno"
                  />
                </Grid.Column>

                <Grid.Column>
                  <SearchField
                    form="SearchColegioForm"
                    fieldID="buscarColegio"
                    fieldName="busqueda"
                    labelText="Búsqueda de Colegios"
                    placeholder="Nombre del Colegio"
                    handleButtonClick={this.handleSearchFieldAction}
                    datosBusqueda={this.props.searchDataColegios}
                    showAddButton={true}
                    botonLink="/nuevo/colegio"
                  />
                </Grid.Column>

                <Grid.Column>
                  <SearchField
                    form="SearchActividadForm"
                    fieldID="buscarActividad"
                    fieldName="busqueda"
                    labelText="Búsqueda de Actividades"
                    placeholder="Nombre de la actividad"
                    handleButtonClick={this.handleSearchFieldAction}
                    datosBusqueda={this.props.searchDataActividades}
                    showAddButton={true}
                    botonLink="/nueva/actividad"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  searchDataAlumnos: state.busquedas.searchDataAlumnos,
  searchDataColegios: state.busquedas.searchDataColegios,
  searchDataActividades: state.busquedas.searchDataActividades,
  listaColegios: state.busquedas.listaColegios,
  listaActividades: state.busquedas.listaActividades
});

const actions = {
  resetSearchData: busquedasOps.resetSearchData,
  fetchSearchDataAlumnos: busquedasOps.fetchSearchDataAlumnos,
  fetchSearchDataColegios: busquedasOps.fetchSearchDataColegios,
  fetchSearchDataActividades: busquedasOps.fetchSearchDataActividades,
  detachSearchData: busquedasOps.detachSearchData
};

export default connect(mapStateToProps, actions)(withRouter(Busquedas));



// WEBPACK FOOTER //
// ./src/pages/inicio/Busquedas.jsx